import * as React from 'react'
import { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Stack, Box } from '@mui/material'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import '../../../App.css'
import '../../../css/modal.scss'
import { updateModal } from '../../../store/common/common_action'
import { getBranchReceiveLastReceivePrint, getUpdateReceive, getUpdateReceiveV2, getUpdateShortReceive } from '../../../store/branchTransferReceive/branchReceive_action'
import LineInput from '../../common/lineinput'
import * as error from '../../common/error_strings'
import { Item } from '../../common/snippets'
import Modal from '../../common/modal'
import LoaderScreen from '../../common/loader'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import moment from 'moment'
import { callAddFontNirmalaNormal } from '../BranchTransfer/fonts/Nirmala-normal'
import { callAddFontNirmalaBold } from '../BranchTransfer/fonts/Nirmala-bold'
import ReceivedItem from './ReceivedItem'
import { focusElemnt, navigation3 } from '../../common/helper'
import { useAtom } from 'jotai'
import { companySettingsAtom } from '../../common/jotaiState/commonStateAtoms'
import { branchTransferFilteredTableRowsAtom } from '../../common/jotaiState/dispatchStateAtoms'
import { GUJRAT_COMPANY_ID } from '../../../helper/companyIdhardcode'
const BottomSection = ({
  getUpdateReceive,
  getUpdateShortReceive,
  getBranchReceiveLastReceivePrint,
  updateModal,
  data,
  topSelectedData,
  tSecDropData,
  selectedData,
  setTSecDropData,
  indexSetState,
  setTopSelectedData,
  setSelectedData,
  setShowBtnList,
  setSelectedChallanData,
  setSelectedVehicleData,
  handleAlert,
  inputCheck,
  getUpdateReceiveV2,
  chaVehWise

}) => {
  const { common, BranchTransferReceiveReducer, delivery } = data
  const { brnchList, cityList, strtCity, loginData, strtBrnch, showModal, modalType, alert, loader, roleRights } = { ...common }
  const { listData } = { ...BranchTransferReceiveReducer }
  const [companySettings] = useAtom(companySettingsAtom)
  const [filteredTableRows] = useAtom(branchTransferFilteredTableRowsAtom)
  const { BTRChallanPortrait } = companySettings

  const { receive, shortReceive, branchreceiveLastReceivePrint } = { ...BranchTransferReceiveReducer }
  const [successModal, setSuccessModal] = useState({
    Receive: { id: 'Receive', lrListLabel: 'Receive popup modal', isSaved: false },
    ShortReceive: { id: 'ShortReceive', lrListLabel: 'Short Receive popup modal', isSaved: false },
    ReceiveSuccess: { id: 'ReceiveSuccess', lrListLabel: 'Receive Success popup modal', isSaved: false },
    ShortReceiveSuccess: { id: 'ShortReceiveSuccess', lrListLabel: 'Short Success Receive popup modal', isSaved: false },
    LastReceivePrint: { id: 'LastReceivePrint', lrListLabel: 'Last Receive Print popup modal', isSaved: false },
    ReceivedItemList: { id: 'ReceivedItemList', lrListLabel: 'Received Item List popup modal', isSaved: false },
  })

  const [selectedPrintData, setSelectedPrintData] = useState(null)
  const [filteredPreviewPdfUrl, setFilteredPreviewPdfUrl] = useState('')
  const [state, setState] = useState({
    Remarks: '',
    LrNo: [],
    BookingID: [],
    shortQtys: [],
    damageQtys: [],
    BranchTransferID: [],
    BranchTransferDetID: [],
    load: false,
    generatePDF: false,
    filteredPreviewGeneratePDF: false,
    received: false,
    lastReceivePrint: false,
    dFromBranchForPrint: '',
  })
  const {
    Remarks,
    LrNo,
    BookingID,
    shortQtys,
    damageQtys,
    BranchTransferID,
    BranchTransferDetID,
    load,
    generatePDF,
    filteredPreviewGeneratePDF,
    received,
    dFromBranchForPrint,
    lastReceivePrint,
  } = state
  // console.log(received)


  function getNumericMonth(monthAbbr) {
    return String(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].indexOf(monthAbbr) + 1).padStart(
      2,
      '0'
    )
  }
  // console.log(89,branchreceiveLastReceivePrint)

  // All UseEffect

  useEffect(() => {
    if (selectedData?.length >= 1) {
      const lr = selectedData?.map((item) => item.LRNO)
      const bookingid = selectedData?.map((item) => item.BookingID)
      const branchTransferId = selectedData?.map((item) => item.BranchTransferID)
      const branchTransferDetId = selectedData?.map((item) => item.BranchTransferDetID)

      const ShortQtys = selectedData.map((item) => 0)
      const DamageQtys = selectedData.map((item) => 0)

      setState({
        ...state,
        LrNo: lr,
        BookingID: bookingid,
        shortQtys: ShortQtys,
        damageQtys: DamageQtys,
        BranchTransferID: branchTransferId,
        BranchTransferDetID: branchTransferDetId,
      })
    } else {
      setState({ ...state, LrNo: [], BookingID: [], shortQtys: [], damageQtys: [] })
    }
  }, [selectedData])

  useEffect(() => {
    if (receive.status == true || receive.status === 'Success') {
      // console.log(77,selectedData)
      getBranchReceiveLastReceivePrint(selectedData)
      updateModal(true, 'ReceiveSuccess')
      setTSecDropData({ ...tSecDropData, selectconsignmentType: 'All', SellectedChallanNumber: "" })
      setState({ ...state, Remarks: '' })
      indexSetState({ showListTable: false, showListAllTable: false })
      setTopSelectedData({
        ...topSelectedData,
        DFromBranch: null,
        SelectedVehicle: "",
        resetData: true,
      })
      setSelectedData([])
      setSelectedChallanData([])
      setSelectedVehicleData([])
      setShowBtnList(true)
    } else {
      handleAlert(receive?.ErrMessage || receive?.Message)
    }
  }, [receive])
  useEffect(() => {
    if (shortReceive.status == true) {
      updateModal(true, 'ShortReceiveSuccess')
      setTSecDropData({ ...tSecDropData, selectconsignmentType: 'All', SellectedChallanNumber: 'All' })
      setState({ ...state, Remarks: '' })
      indexSetState({ showListTable: false, showListAllTable: false })
      setTopSelectedData({
        ...topSelectedData,
        DFromBranch: null,
        SelectedVehicle: "",
        resetData: true,
      })
      setShowBtnList(true)
      setSelectedChallanData([])
      setSelectedVehicleData([])
      setSelectedData([])
    } else {
      handleAlert(shortReceive?.ErrMessage)
    }
  }, [shortReceive])

  useEffect(() => {
    if (showModal && modalType === 'FilteredTablePreview' && filteredPreviewGeneratePDF) {
      generateFilteredTablePreviewPdf()
    }
  }, [showModal, modalType, filteredPreviewGeneratePDF])
  //All useEffect End
  const formatPreviewDate = (value) => {
    if (!value) return ''
    const parsed = moment(value)
    return parsed.isValid() ? parsed.format('DD-MM-YYYY') : value
  }

  const getFilteredTablePreviewRows = () => {
    let totalUnits = 0
    let totalAmount = 0

    const rows = (filteredTableRows || []).map((item, index) => {
      const quantity = Number(item?.Quantity || 0)
      const amount = Number(item?.NetAmount || 0)
      totalUnits += quantity
      totalAmount += amount

      return {
        srNo: index + 1,
        LRNO: item?.LRNO || '',
        ManualLRNo: item?.ManualLRNo || '',
        BookingDate: formatPreviewDate(item?.BookingDate),
        DescriptionDet: item?.ConsignmentData?.length === 1 ? item?.DescriptionDet || '' : 'Multi',
        PaymentType: item?.PaymentType || '',
        Quantity: quantity,
        Sender: item?.Sender || '',
        RecName: item?.RecName || '',
        FromCity: item?.FromCity || '',
        ToCity: item?.ToCity || '',
        NetAmount: amount,
      }
    })

    rows.push({
      srNo: 'Total',
      Quantity: totalUnits,
      NetAmount: totalAmount,
    })

    return rows
  }

  const generateFilteredTablePreviewPdf = (isSave = false) => {
    if (!filteredTableRows?.length) {
      setState((prev) => ({ ...prev, filteredPreviewGeneratePDF: false }))
      updateModal(false)
      handleAlert('No filtered branch transfer rows found')
      return
    }

    jsPDF.API.events.push(['addFonts', callAddFontNirmalaBold])
    jsPDF.API.events.push(['addFonts', callAddFontNirmalaNormal])

    const pdfColumns = [
      { header: 'SN', dataKey: 'srNo' },
      { header: 'LR No.', dataKey: 'LRNO' },
      { header: 'Manual LR', dataKey: 'ManualLRNo' },
      { header: 'Booking Date', dataKey: 'BookingDate' },
      { header: 'Consign Type', dataKey: 'DescriptionDet' },
      { header: 'Payment Type', dataKey: 'PaymentType' },
      { header: 'Units', dataKey: 'Quantity' },
      { header: 'Sender', dataKey: 'Sender' },
      { header: 'Receiver', dataKey: 'RecName' },
      { header: 'From City', dataKey: 'FromCity' },
      { header: 'To City', dataKey: 'ToCity' },
      { header: 'Amount', dataKey: 'NetAmount' },
    ]
    const previewRows = getFilteredTablePreviewRows()
    const doc = new jsPDF({
      unit: 'px',
      compress: true,
      orientation: pdfColumns.length > 10 ? 'l' : 'p',
    })

    const totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `Branch Transfer Filter Preview.pdf`,
      subject: 'Branch Transfer Filter Preview',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Branch Transfer Receive',
      creator: 'MTLPL',
    })

    autoTable(doc, {
      margin: { top: 24, left: 8, right: 8, bottom: 10 },
      columns: pdfColumns,
      body: previewRows,
      theme: 'grid',
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [30, 89, 167],
        fontSize: 7,
      },
      bodyStyles: {
        font: 'Nirmala',
        fontSize: 7,
      },
      didParseCell: (data) => {
        if (data.row.raw?.srNo === 'Total') {
          data.cell.styles.fontStyle = 'bold'
          data.cell.styles.fillColor = [208, 220, 238]
        }
      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 8, 8, 10, 10)
        doc.setFontSize(12)
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System | Transfer Filter Preview', 20, 15)
        doc.setFontSize(9).setFont(undefined, 'bold')
        doc.text(`Company Name : ${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 15, 'right')
        doc.setFont('Nirmala', 'normal')

        const pageHeight = doc.internal.pageSize.height ? doc.internal.pageSize.height : doc.internal.pageSize.getHeight()
        const pageWidth = doc.internal.pageSize.width ? doc.internal.pageSize.width : doc.internal.pageSize.getWidth()
        doc.setDrawColor(0, 0, 0)
        doc.setLineWidth(0.2)
        doc.line(0, pageHeight - 8, pageWidth, pageHeight - 8)
        let pageText = 'Page : ' + doc.internal.getNumberOfPages()
        if (typeof doc.putTotalPages === 'function') {
          pageText = pageText + ' of ' + totalPagesExp
        }
        doc.text(`Report By : ${loginData.strUserName} [ ${loginData.strBranchName} ]`, 8, pageHeight - 2)
        doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, 190, pageHeight - 2)
        doc.text(pageText, pageWidth - 70, pageHeight - 2)
      },
    })

    doc.setFont('Nirmala')
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }

    const pdfUrl = doc.output('bloburl')
    setFilteredPreviewPdfUrl(pdfUrl)

    if (isSave) {
      doc.save(`Branch Transfer Filter Preview ${moment(new Date()).format('DD-MMM-YYYY HH-mm')}.pdf`)
    }

    setState((prev) => ({ ...prev, filteredPreviewGeneratePDF: false }))
  }

  const printClick = () => {
    // if (selectedPrintData == null) {
    if (branchreceiveLastReceivePrint === undefined || !branchreceiveLastReceivePrint.length) {
      // console.log('hii')
      updateModal(false, 'LastReceivePrint')
      handleAlert('No Receive Found')
    } else {
      setState({ ...state, load: true, generatePDF: true })
      jsPDF.API.events.push(['addFonts', callAddFontNirmalaBold])
      jsPDF.API.events.push(['addFonts', callAddFontNirmalaNormal])
      let UnitsTotal = 0
      let GrossAmt = 0
      const todayDate = new Date().toString().split(' ')
      const year = todayDate[3]
      const day = todayDate[2]
      const month = todayDate[1]
      const currentDate = `${day}-${month}-${year}`
      // console.log(currentDate)
      if (lastReceivePrint == false) {
        branchreceiveLastReceivePrint?.forEach((item, i) => {
          item.srNo = i + 1
          item.TransferByBranch = dFromBranchForPrint
          item.ReceivedByBranch = strtBrnch.BranchName
          item.ReceivedDate = `${day}-${month}-${year}`
          UnitsTotal += item.Quantity
          GrossAmt += item.NetAmount
        })
        branchreceiveLastReceivePrint.push({
          srNo: 'Total',
          Quantity: UnitsTotal,
          NetAmount: GrossAmt,
        })
        branchreceiveLastReceivePrint.unshift({
          srNo: `Transfer Type : ${branchreceiveLastReceivePrint?.[0]?.TransferType}`,
          TransferByBranch: `Destination City : ${branchreceiveLastReceivePrint?.[0]?.ToCity}`,
          RecName: `Destination Branch : ${branchreceiveLastReceivePrint?.[0]?.DestinationBranchName}`,
        })
      }

      const columnDefs = [
        {
          headerName: 'Sr. No.',
          exportHead: 'SN',
          field: 'srNo',
          xlCol: { dataType: 'number', dataFormatter: null },
        },
        {
          headerName: 'LR No.',
          exportHead: 'LR No.',
          field: 'LRNO',
          xlCol: { dataType: 'string', dataFormatter: null },
        },
        {
          headerName: 'Transfer Date',
          exportHead: 'Transfer Date',
          field: 'BookingDate',
          xlCol: { dataType: 'string', dataFormatter: null },
        },
        {
          headerName: 'Received Date',
          exportHead: 'Received Date',
          field: 'ReceivedDate',
          xlCol: { dataType: 'string', dataFormatter: null },
        },
        {
          headerName: 'Transfer By Branch',
          exportHead: 'Transfer By Branch',
          field: 'TransferByBranch',
          xlCol: { dataType: 'quantity', dataFormatter: null },
        },
        {
          headerName: 'Received By Branch',
          exportHead: 'Received By Branch',
          field: 'ReceivedByBranch',
          xlCol: { dataType: 'quantity', dataFormatter: null },
        },
        {
          headerName: 'Sender Name',
          exportHead: 'Sender Name',
          field: 'Sender',
          xlCol: { dataType: 'string', dataFormatter: null },
        },
        {
          headerName: 'Receiver Name',
          exportHead: 'Receiver Name',
          field: 'RecName',
          xlCol: { dataType: 'string', dataFormatter: null },
        },
        {
          headerName: 'Vehicle No',
          exportHead: 'Vehicle No',
          field: 'VehicleNo',
          xlCol: { dataType: 'quantity', dataFormatter: null },
        },
        {
          headerName: 'Challan No.',
          exportHead: 'Challan No.',
          field: 'VoucherNo',
          xlCol: { dataType: 'quantity', dataFormatter: null },
        },
        {
          headerName: 'Payment Type',
          exportHead: 'Payment Type',
          field: 'PaymentType',
          xlCol: { dataType: 'quantity', dataFormatter: null },
        },
        {
          headerName: 'Consignment Type',
          exportHead: 'Consignment Type',
          field: 'DescriptionDet',
          xlCol: { dataType: 'quantity', dataFormatter: null },
        },
        {
          headerName: 'Units',
          exportHead: 'Units',
          field: 'Quantity',
          xlCol: { dataType: 'quantity', dataFormatter: null },
        },
        {
          headerName: 'Gross Amount',
          exportHead: 'Gross Amount',
          field: 'NetAmount',
          xlCol: { dataType: 'string', dataFormatter: null },
        },
      ]
      const pdfColumns = columnDefs.map((col) => {
        return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
      })

      const doc = new jsPDF({ orientation: BTRChallanPortrait ? 'p' : 'l' })

      doc.autoTableSetDefaults({
        headStyles: { fontSize: 6, width: 'auto', halign: 'left', fillColor: [30, 89, 167] },
      })

      var totalPagesExp = '{total_pages_count_string}'
      const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
        const doc = data.doc

        // Footer
        var pageSize = doc.internal.pageSize
        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
        var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
        doc.setDrawColor(0, 0, 0)
        doc.setLineWidth(0.2)
        doc.line(0, pageHeight - 7, pageWidth, pageHeight - 7)
        var str = 'Page : ' + doc.internal.getNumberOfPages()
        if (typeof doc.putTotalPages === 'function') {
          str = str + ' of ' + totalPagesExp
        }
        doc.setFontSize(9)
        doc.text(str, 5 + 260, pageHeight - 2)
        doc.setFont('Nirmala', 'normal')
        doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 5, pageHeight - 2)
        doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, 5 + 150, pageHeight - 2)
      }

      let drawCell = function (data) {
        var rows = data.table.body
        rows.map((val) => {
          if (Object.keys(val.raw).length == 3) {
            if (val.raw.srNo === 'Total') {
              val.cells[0].colSpan = 12
              val.cells[0].styles.font = 'Nirmala'
              val.cells[0].styles.fontStyle = 'bold'
              val.cells[0].styles.fontSize = '7'
              val.cells[0].styles.fillColor = [208, 220, 238]

              val.cells[12].colSpan = 1
              val.cells[12].styles.font = 'Nirmala'
              val.cells[12].styles.fontStyle = 'bold'
              val.cells[12].styles.fontSize = '7'
              val.cells[12].styles.fillColor = [208, 220, 238]

              val.cells[13].colSpan = 1
              val.cells[13].styles.font = 'Nirmala'
              val.cells[13].styles.fontStyle = 'bold'
              val.cells[13].styles.fontSize = '7'
              val.cells[13].styles.fillColor = [208, 220, 238]
            } else {
              val.cells[0].colSpan = 4
              val.cells[0].styles.font = 'Nirmala'
              val.cells[0].styles.fontStyle = 'bold'
              val.cells[0].styles.fontSize = '7'
              val.cells[0].styles.fillColor = [244, 250, 254]
              val.cells[0].styles.halign = 'left'

              val.cells[4].colSpan = 3
              val.cells[4].styles.font = 'Nirmala'
              val.cells[4].styles.fontStyle = 'bold'
              val.cells[4].styles.fontSize = '7'
              val.cells[4].styles.fillColor = [244, 250, 254]
              val.cells[4].styles.halign = 'left'

              val.cells[7].colSpan = 13
              val.cells[7].styles.font = 'Nirmala'
              val.cells[7].styles.fontStyle = 'bold'
              val.cells[7].styles.fontSize = '7'
              val.cells[7].styles.fillColor = [244, 250, 254]
              val.cells[7].styles.halign = 'left'
            }
          }
        })
      }

      doc.setProperties({
        title: `Receive.pdf`,
        subject: 'Receive Summary Report',
        author: 'Maven Tech Labs Pvt. Ltd.',
        keywords: 'maven tech, Cargo system, Receive',
        creator: 'MTLPL',
      })

      autoTable(doc, {
        margin: { top: 20, left: 5, right: 5, bottom: 5 },
        alternateRowStyles: {
          fillColor: [255, 255, 255],
        },
        columns: pdfColumns,
        body: branchreceiveLastReceivePrint,
        columnStyles: {
          0: { halign: 'right', fontSize: 7 },
          1: { fontSize: 7, font: 'Nirmala' },
          2: { fontSize: 7, font: 'Nirmala' },
          3: { fontSize: 7, font: 'Nirmala' },
          4: { fontSize: 7, font: 'Nirmala', minCellWidth: 18 },
          5: { fontSize: 7, font: 'Nirmala', minCellWidth: 18 },
          6: { halign: 'left', fontSize: 7, font: 'Nirmala', },
          7: { halign: 'left', fontSize: 7, font: 'Nirmala', },
          8: { halign: 'left', fontSize: 7, font: 'Nirmala' },
          9: { halign: 'right', fontSize: 7 },
          10: { halign: 'left', fontSize: 7, font: 'Nirmala' },
          11: { halign: 'left', fontSize: 7, font: 'Nirmala' },
          12: { halign: 'right', fontSize: 7 },
          13: { halign: 'right', fontSize: 7 },
        },
        theme: 'grid',
        headStyles: {
          fillColor: [30, 89, 167],
        },
        didParseCell: (data) => {
          drawCell(data)
        },
        didDrawPage: function (data) {
          doc.setTextColor(40)
          doc.addImage('/images/logo-66.png', 'JPEG', 5, 8, 10, 10)
          doc.setFontSize(12)
          doc.setTextColor(16, 79, 162)
          doc.text('Cargo System', 17, 14)
          doc.setDrawColor(16, 79, 162)
          doc.setLineWidth(0.4)
          doc.line(46, 11, 46, 15)

          doc.setFontSize(12)
          doc.setTextColor(16, 79, 162)
          doc.text(`Transfer Receive Report`, 48, 14)

          doc.setFontSize(10).setFont(undefined, 'bold')
          doc.text(`Company Name : ${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 14,'right')
          jsPdfHeaderFooter(data, loginData, totalPagesExp)
        },
      })
      doc.setFont('Nirmala')

      if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp)
      }
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        document.getElementById('output').data = doc.output('datauristring', 'Receive.pdf')
      }, 2000)
    }
  }

  const onKeyDown = (id, e) => {
    switch (id) {
      case 'branchReceivebtn':
        if (e.key === 'Enter') {
        } else if (e.key === 'Escape') {
          focusElemnt('remarksBranchReceive')
        }
        break
      case 'remarks':
        if (e.key === 'Enter') {
          focusElemnt('branchReceivebtn')
        } else if (e.key === 'Escape') {
          focusElemnt('showListBranchReceive')
        }
        break
      default:
        break
    }
  }
  const onClick = (id) => {
    switch (id) {
      case 'Receivebtn':
        if (selectedData.length < 1) {
          handleAlert(error.SELECT_LR)
        } else {
          updateModal(true, 'Receive')
        }
        break
      case 'confirmReceive':
        if (inputCheck) {
          let bkgID = selectedData.map(({ BookingID }) => BookingID)
          const body = {
            FromBranchID: topSelectedData.DFromBranch.BranchID,
            CurrentBranchID: strtBrnch.BranchID,
            FromCityID: strtCity.CityID,
            CurrentCityID: strtCity.CityID,
            CompanyID: loginData.intCompanyID,
            VoucherNo: tSecDropData.SellectedChallanNumber === ""
              ? 0
              : tSecDropData?.SellectedChallanNumber?.VoucherNo,
            IsInMovement: 1,
            Mode: 1,
            Date: moment(new Date()).format('YYYY-MM-DD'),
            VehicleNo: chaVehWise === 1 ? '' : topSelectedData.SelectedVehicle.VehicleNo || "",
            VehicleID: chaVehWise === 1 ? 0 : topSelectedData.SelectedVehicle.VehicleID || 0,
            UserID: loginData.intUserID,
            Remarks: Remarks,
            IsBranchReceiveAllLrs: listData?.Table?.length === selectedData?.length ? 1 : 0,
            ExceptionDispatchIDs: listData?.Table?.filter((item) => !bkgID?.includes(item.BookingID))
              ?.map((obj) => obj?.BranchTransferID)
              ?.join('^'),
            ExceptionDispatchDetIDs: listData?.Table?.filter((item) => !bkgID?.includes(item.BookingID))
              ?.map((obj) => obj?.BranchTransferDetID)
              ?.join('^')
          }

          getUpdateReceiveV2(body)
        } else {
          const LRno = LrNo.join('^').toString()
          const branchId = BranchTransferID.join('^').toString()
          const branchDetId = BranchTransferDetID.join('^').toString()
          const bookingid = BookingID.join('^').toString()
          const shortQtyss = shortQtys.join('^').toString()
          const DamageQtys = damageQtys.join('^').toString()
          const receiveObj = {
            intSendingCityID: strtCity.CityID,
            intReceivedCityID: strtCity.CityID,
            intSendingBranchID: topSelectedData.DFromBranch.BranchID,
            intReceivedBranchID: strtBrnch.BranchID,
            strVehicleNo: topSelectedData.SelectedVehicle.VehicleNo,
            strRemarks: Remarks,
            intVehicleID: topSelectedData.SelectedVehicle.VehicleID,
            strBranchTransferIDs: branchId,
            strBranchTransferDetIDs: branchDetId,
            strLRNos: LRno,
            strShortQtys: shortQtyss,
            strDamageQtys: DamageQtys,
            strBookingIDs: bookingid,
          }
          getUpdateReceive(loginData, receiveObj)
          // setSelectedPrintData(null)
          // setSelectedPrintData(selectedData)
        }
        setState({
          ...state,
          dFromBranchForPrint: topSelectedData?.DFromBranch?.BranchName,
          lastReceivePrint: false,
          load: false,
          generatePDF: false,
        })
        updateModal(false, 'Receive')

        break
      case 'CLosePopupReceive':
        updateModal(false, 'Receive')
        break
      case 'ShortReceivebtn':
        if (selectedData.length < 1) {
          handleAlert(error.SELECT_LR)
        } else {
          updateModal(true, 'ShortReceive')
        }
        break
      case 'confirmShortReceive':
        const shortbranchId = BranchTransferID.join('^').toString()
        const shortbookingid = BookingID.join('^').toString()
        const shortreceiveObj = {
          strBookingIDs: shortbookingid,
          strBranchTransferIDS: shortbranchId,
        }
        getUpdateShortReceive(loginData, shortreceiveObj)
        updateModal(false, 'ShortReceive')
        break
      case 'CLosePopupShortReceive':
        updateModal(false, 'ShortReceive')
        break
      case 'successfullReceive':
        updateModal(false, 'ReceiveSuccess')
        break
      case 'successfullReceiveclose':
        updateModal(false, 'ReceiveSuccess')
        break
      case 'successfullShortReceive':
        updateModal(false, 'ShortReceiveSuccess')
        break
      case 'SuccessFullReceive':
        setState({ ...state, received: true })
        printClick()
        break
      default:
        break
    }
  }
  const handleKeyDownConfirm = (e, id) => {
    if (e.keyCode === 37) {
      if (id == "deliveryno") {
        focusElemnt("deliveryyes")
      } else if (id == "deliveryyes") {
        focusElemnt("deliveryno")
      }
    } else if (e.keyCode == 39) {
      if (id == "deliveryno") {
        focusElemnt("deliveryyes")
      } else if (id == "deliveryyes") {
        focusElemnt("deliveryno")
      }
    }
  }
  const handleKeyDownSuccess = (e, id) => {
    if (e.keyCode === 37) {
      if (id == "deliveryno") {
        focusElemnt("deliveryyes")
      } else if (id == "deliveryyes") {
        focusElemnt("deliveryno")
      }
    } else if (e.keyCode == 39) {
      if (id == "deliveryno") {
        focusElemnt("deliveryyes")
      } else if (id == "deliveryyes") {
        focusElemnt("deliveryno")
      }
    }
  }
  // All popup
  const ReceiveModal = (isRecve = false) => {
    return (
      <Modal headTxt={`Confirm`} width={'25%'} updateModal={updateModal}>
        <Stack>
          <Box style={{ margin: '20px', fontSize: '16px' }}>
            <div>
              Please confirm you want to Branch Receive consignment/s from {topSelectedData?.DFromBranch?.BranchName} to{' '}
              {strtBrnch?.BranchName}
            </div>
          </Box>
        </Stack>
        <Stack>
          {/* background: '#f15a22' */}
          <div className="modal-btn-grp">
            <button
              className="select-lr-btn"
              id="deliveryyes"
              style={{ background: '#fe5200', color: 'white', padding: '7px 20px', cursor: 'pointer', fontSize: '12px' }}
              onClick={() => onClick('confirmReceive')}
              onKeyDown={(e) => handleKeyDownConfirm(e, 'deliveryyes')}
            >
              YES
            </button>
            <Button
              id="deliveryno"
              className="select-lr-btn"
              variant="outlined"
              autoFocus
              color="error"
              onClick={() => onClick('CLosePopupReceive')}
              style={{ cursor: 'pointer', fontSize: '12px' }}
              onKeyDown={(e) => handleKeyDownConfirm(e, 'deliveryno')}
            >
              NO
            </Button>
          </div>
        </Stack>
      </Modal>
    )
  }

  const ReceiveSuccessModal = (isRecve = false) => {
    return (
      <Modal headTxt={`Success`} width={load ? '90%' : '25%'} updateModal={updateModal}>
        <>
          {load ? (
            ''
          ) : (
            <>
              <Stack>
                <Box style={{ margin: '20px', fontSize: '16px' }}>
                  <div>{receive.Message}</div>
                  <div>Do you want Print ?</div>
                </Box>
              </Stack>
              <Stack>
                <div className="modal-btn-grp">
                  <button
                    className="select-lr-btn"
                    id="deliveryyes"
                    style={{ background: '#fe5200', cursor: 'pointer', color: 'white', padding: '7px 20px', fontSize: '12px' }}
                    onClick={() => printClick()}
                    onKeyDown={(e) => handleKeyDownSuccess(e, 'deliveryyes')}
                  >
                    YES
                  </button>
                  <Button
                    className="select-lr-btn"
                    variant="outlined"
                    id="deliveryno"
                    color="error"
                    onClick={() => updateModal(false, 'ReceiveSuccess')}
                    style={{ cursor: 'pointer', fontSize: '12px' }}
                    onKeyDown={(e) => handleKeyDownSuccess(e, 'deliveryno')}
                    autoFocus
                  >
                    NO
                  </Button>
                </div>
              </Stack>
            </>
          )}
          {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
          {load ? (
            <object
              id="output"
              type="application/pdf"
              width="1330"
              height="600"
              title="MTLPL -Cargo System - After Transfer Summary Report"
              aria-label="MTLPL -Cargo System - After Transfer Summary Report"
            ></object>
          ) : (
            ''
          )}
        </>
      </Modal>
    )
  }

  const ShortReceiveModal = (isRecve = false) => {
    return (
      <Modal headTxt={`Confirm`} width={'25%'} updateModal={updateModal}>
        <Stack>
          <Box style={{ margin: '20px', fontSize: '16px' }}>
            <div>
              Please confirm you want to Short Branch Receive consignment/s from {topSelectedData.DFromBranch.BranchName} to{' '}
              {strtBrnch.BranchName}
            </div>
          </Box>
        </Stack>
        <Stack>
          {/* background: '#f15a22' */}
          <div className="modal-btn-grp">
            <button
              autoFocus
              id="deliveryyes"
              style={{ background: '#fe5200', color: 'white', padding: '7px 20px', cursor: 'pointer', fontSize: '12px' }}
              onClick={() => onClick('confirmShortReceive')}
            >
              YES
            </button>
            <Button
              className="select-lr-btn"
              variant="outlined"
              color="error"
              onClick={() => onClick('CLosePopupShortReceive')}
              style={{ cursor: 'pointer', fontSize: '12px' }}
            >
              NO
            </Button>
          </div>
        </Stack>
      </Modal>
    )
  }
  const ShortReceiveSuccessModal = (isRecve = false) => {
    return (
      <Modal headTxt={`Success`} width={'25%'} updateModal={updateModal}>
        <Stack>
          <Box style={{ margin: '10px', fontSize: '16px' }}>
            <div> Successfull Short Receive of Selected LR</div>
          </Box>
        </Stack>
        <Stack>
          <div className="modal-btn-grp" style={{ marginRight: '10px' }}>
            <button
              autoFocus
              id="deliveryyes"
              style={{ background: '#fe5200', cursor: 'pointer', color: 'white', padding: '7px 20px', fontSize: '12px' }}
              onClick={() => onClick('successfullShortReceive')}
            >
              Ok
            </button>
          </div>
        </Stack>
      </Modal>
    )
  }

  const LastReceivePrint = (isRecve = false) => {
    return (
      <Modal headTxt={` Last Receive Print`} width={load ? '90%' : '25%'} updateModal={updateModal}>
        {load ? (
          ''
        ) : (
          <>
            <Stack>
              <Box style={{ margin: '20px', fontSize: '16px' }}>
                <div>Do you want to Last Receive Print ?</div>
              </Box>
            </Stack>
            <Stack>
              <div className="modal-btn-grp">
                <button
                  autoFocus
                  id="deliveryyes"
                  style={{ background: '#fe5200', cursor: 'pointer', color: 'white', padding: '7px 20px', fontSize: '12px' }}
                  onClick={() => onClick('SuccessFullReceive')}
                >
                  YES
                </button>

                <Button
                  className="select-lr-btn"
                  variant="outlined"
                  color="error"
                  onClick={() => updateModal(false, 'LastReceivePrint')}
                  style={{ cursor: 'pointer', fontSize: '12px' }}
                >
                  NO
                </Button>
              </div>
            </Stack>
          </>
        )}
        {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
        {load ? (
          <object
            id="output"
            type="application/pdf"
            width="1330"
            height="600"
            title="MTLPL -Cargo System - After Transfer Summary Report"
            aria-label="MTLPL -Cargo System - After Transfer Summary Report"
          ></object>
        ) : (
          ''
        )}
      </Modal>
    )
  }

  const ReceivedItemList = (isRecve = false) => {
    return (
      <Modal headTxt={` Transfer Received Item List`} width={'95%'} updateModal={updateModal}>
        <Stack>
          <ReceivedItem handleAlert={handleAlert} />
        </Stack>
      </Modal>
    )
  }
  const FilteredTablePreviewModal = () => {
    return (
      <Modal headTxt={`Transfer Filter Preview`} headText2={`${filteredTableRows.length} row(s)`} width={'95%'} updateModal={updateModal}>
        <>
          {filteredPreviewGeneratePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
          <Stack direction="row" spacing={2} style={{ padding: '12px 16px 0 16px', justifyContent: 'flex-end' }}>
            <Button
              variant="outlined"
              style={{ borderColor: '#fe5200', color: '#fe5200', fontSize: '13px', fontWeight: 'bold', marginBottom:'10px' }}
              onClick={() => generateFilteredTablePreviewPdf(true)}
              disabled={!filteredTableRows?.length || filteredPreviewGeneratePDF}
            >
              Download PDF
            </Button>
          </Stack>
          {filteredPreviewPdfUrl ? (
            <object
              id="branchTransferFilteredPreviewOutput"
              type="application/pdf"
              width="100%"
              height="650"
              data={filteredPreviewPdfUrl}
              title="MTLPL - Cargo System - Branch Transfer Filter Preview"
              aria-label="MTLPL - Cargo System - Branch Transfer Filter Preview"
            ></object>
          ) : (
            <div style={{ padding: '24px', minHeight: '200px' }}>
              {filteredPreviewGeneratePDF ? '' : 'Preparing preview...'}
            </div>
          )}
        </>
      </Modal>
    )
  }


  return (
    <>
      {/* {loader ? <LoaderScreen /> : ''} */}
      <div className="bottom-section" style={{ width: '100%' }}>
        <Stack
          direction="row"
          divider={
            <Divider
              orientation="vertical"
              sx={{
                width: '2px',
                margin: '0px -16px 0px 0px !important',
                //   backgroundColor: "#0086ff",
                backgroundColor: '#DDD',
              }}
              flexItem
            />
          }
          spacing={2}
          sx={{ background: '#f0fcf4', width: '100%' }}
        >
          <Item sx={{ width: '30%', paddingTop: '16px', background: '#f0fcf4' }}>
            <Box
              sx={{
                flexGrow: 1,
                width: '100%',
                display: 'inline-flex',
                padding: '0% 10px',
                background: '#f0fcf4',
              }}
            >
              <Item sx={{ width: '100%', background: '#f0fcf4' }}>
                <div className={'input--wrapper'}>
                  <LineInput
                    id="remarksBranchReceive"
                    type="text"
                    name={'SenGstnNo'}
                    label={`Remarks`}
                    value={Remarks}
                    // onKeyDown={(e) => onKeyDown('remarks', e)}
                    onKeyDown={(e) => navigation3(e, 'branchReceivebtn', 'checkbox_0')}
                    onChange={(e) => setState({ ...state, Remarks: e.target.value })}
                  // disabled={true}
                  />
                </div>
              </Item>
            </Box>
          </Item>
          <Item sx={{ width: '70%', paddingTop: '16px', background: '#f0fcf4' }}>
            <Box
              sx={{
                flexGrow: 1,
                width: '100%',
                display: 'flex',
                padding: '0% 10px',
                // marginTop: "15px",
                background: '#f0fcf4',
              }}
            >
              {loginData.intCompanyID === GUJRAT_COMPANY_ID && (
                <Item sx={{ width: '100%', background: '#f0fcf4' }}>
                  <Button
                    variant="outlined"
                    sx={{ width: '100%' }}
                    style={{
                      borderColor: filteredTableRows?.length ? '#fe5200' : '#cccccc',
                      color: filteredTableRows?.length ? '#fe5200' : '#000',
                      fontSize: '15px',
                      fontWeight: 'bold',
                      textTransform: 'Uppercase',
                    }}
                    onClick={() => {
                      if (!filteredTableRows?.length) {
                        handleAlert('No filtered branch transfer rows found')
                        return
                      }
                      setFilteredPreviewPdfUrl('')
                      setState((prev) => ({ ...prev, filteredPreviewGeneratePDF: true }))
                      updateModal(true, 'FilteredTablePreview')
                    }}
                    disabled={!filteredTableRows?.length}
                  >
                    Print
                  </Button>
                </Item>
              )}
              <Item sx={{ width: '100%', background: '#f0fcf4' }}>
                <Button
                  variant="outlined"
                  sx={{ width: '100%' }}
                  style={{ borderColor: '#fe5200', color: '#fe5200', fontSize: '15px', fontWeight: 'bold', textTransform: 'Uppercase' }}
                  onClick={() => updateModal(true, "ReceivedItemList")}
                >
                  Received Item Lists
                </Button>
              </Item>
              <Item sx={{ width: '100%', background: '#f0fcf4' }}>
                <Button
                  variant="outlined"
                  sx={{ width: '100%' }}
                  style={{ borderColor: '#fe5200', color: '#fe5200', fontSize: '15px', fontWeight: 'bold', textTransform: 'Uppercase' }}
                  onClick={() => {
                    setState({ ...state, load: false, generatePDF: false, lastReceivePrint: true })
                    updateModal(true, 'LastReceivePrint')
                  }}
                >
                  Last Receive Print
                </Button>
              </Item>
              <Item sx={{ width: '100%', background: '#f0fcf4' }}>
                <Button
                  variant="outlined"
                  sx={{ width: '100%' }}
                  style={{ borderColor: '#fe5200', color: '#fe5200', fontSize: '15px', fontWeight: 'bold', textTransform: 'Uppercase' }}
                  onClick={() => onClick('ShortReceivebtn')}
                  disabled={roleRights?.Table1?.[0]?.AllowShortReceipt == 0}
                >
                  {' '}
                  Short Receive
                </Button>
              </Item>
              <Item sx={{ width: '100%', background: '#f0fcf4' }}>
                <Button
                  variant="contained"
                  id="branchReceivebtn"
                  sx={{ width: '100%' }}
                  style={{ backgroundColor: '#fe5200', fontSize: '15px', textTransform: 'Uppercase', color: '#fff', fontWeight: 'bold' }}
                  // onKeyDown={(e) => onKeyDown('branchReceivebtn', e)}
                  onKeyDown={(e) => navigation3(e, 'dispatchBranchReceive', "remarksBranchReceive", () => { })}
                  onClick={() => onClick('Receivebtn')}
                >
                  {' '}
                  Receive
                </Button>
              </Item>
            </Box>
          </Item>
        </Stack>
      </div>
      {showModal && [successModal.Receive.id].includes(modalType) && ReceiveModal(successModal.Receive.id)}
      {showModal && [successModal.ShortReceive.id].includes(modalType) && ShortReceiveModal(successModal.ShortReceive.id)}
      {showModal && [successModal.ReceiveSuccess.id].includes(modalType) && ReceiveSuccessModal(successModal.ReceiveSuccess.id)}
      {showModal && [successModal.LastReceivePrint.id].includes(modalType) && LastReceivePrint(successModal.LastReceivePrint.id)}
      {showModal && [successModal.ReceivedItemList.id].includes(modalType) && ReceivedItemList(successModal.ReceivedItemList.id)}
      {showModal && 'FilteredTablePreview'===modalType && FilteredTablePreviewModal()}
      {showModal &&
        [successModal.ShortReceiveSuccess.id].includes(modalType) &&
        ShortReceiveSuccessModal(successModal.ShortReceiveSuccess.id)}

    </>
  )
}

const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
  updateModal,
  getUpdateReceive,
  getUpdateShortReceive,
  getBranchReceiveLastReceivePrint,
  getUpdateReceiveV2,

}

export default connect(mapStateToProps, mapDispatchToProps)(BottomSection)
